import { PARENT_COMPAIGN_API_URL } from "../components/Shared/constant";

const GetParentCampaign = async (accessToken,parentId) => {
    const responce = window.axios.get(`${PARENT_COMPAIGN_API_URL}/${parentId}`, {
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + accessToken,
    },
  }).then(function (result) {
        return {
          ...result.data,
          status:200
        };
    }).catch(function (result) {
        return {
          ...result?.response?.data,
          status:result?.response?.status
        }
    });
    return responce;
};
  
export default GetParentCampaign;